module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filters-section is-hidden"
  }, [_c('div', {
    staticClass: "filters-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "filters__column filters__column--right"
  }, [_c('div', {
    staticClass: "filters__choices"
  }, _vm._l((_vm.filters), function(filter) {
    return _c('div', {
      staticClass: "filters__choice",
      class: {
        'filters__choice--active': _vm.currentFilter == filter.value
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.clickFilter(filter.value)
        }
      }
    }, [_c('span', {
      staticClass: "choice-inner"
    }, [_vm._v(_vm._s(_vm._f("capitalize")(filter.name)))])])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filters__column filters__column--left"
  }, [_c('div', {
    staticClass: "filters__question"
  }, [_c('h1', [_vm._v("Aujourd’hui"), _c('br'), _vm._v("vous vous sentez ?")])])])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-06520348!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/filters.vue
 ** module id = 746
 ** module chunks = 2
 **/